import { useEffect, useMemo, useState } from "react";
import { Loader2, Plus, Search } from "lucide-react";
import { browseProducts, ron } from "@/lib/bf";
import { BFGamaBack, BFGamaTiles, gamasFor, inGama } from "./BFGamas";

export default function BFAgentBrowse({ cfg, onAdd }) {
  const [brand, setBrand] = useState("");
  const [rows, setRows] = useState(null);
  const [g, setG] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { if (!brand) return; setRows(null); setG(null); browseProducts(brand).then(setRows).catch(() => setRows([])); }, [brand]);
  const gamas = useMemo(() => {
    if (!rows) return [];
    const ids = [...new Set(rows.map((r) => r.key.split(":")[2]))];
    return gamasFor(cfg, brand, ids);
  }, [rows, cfg, brand]);
  const list = (rows || []).filter((r) => (!g || inGama(r, g)) && (!q.trim() || `${r.name} ${r.code}`.toLowerCase().includes(q.trim().toLowerCase())));
  return (
    <div className="bf-ao-browse" data-testid="bf-ao-browse">
      <span className="st-label">Sau alege din branduri și game</span>
      <div className="bf-ao-brands">
        {(cfg.brands || []).map((b) => <button key={b.id} type="button" className={`bf-picker-chip ${brand === b.id ? "is-on" : ""}`} onClick={() => setBrand(brand === b.id ? "" : b.id)} data-testid={`bf-ao-brand-${b.id}`}>{b.name}</button>)}
      </div>
      {brand && !rows && <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p>}
      {rows && !g && gamas.length > 1 && <BFGamaTiles gamas={gamas} onPick={(x) => { setG(x); setQ(""); }} />}
      {rows && (g || gamas.length <= 1) && (
        <>
          {g && <BFGamaBack g={g} onBack={() => setG(null)} />}
          <label className="bf-stock-search"><Search size={15} /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filtrează: cod, nuanță, denumire" data-testid="bf-ao-browse-q" /></label>
          <ul className="bf-ao-prods">
            {list.slice(0, 300).map((r) => (
              <li key={r.key}><button type="button" onClick={() => onAdd(r)} data-testid={`bf-ao-browse-${r.key}`}><span>{r.name}<small> · cod {r.code}</small></span><small>{ron(r.list)} <Plus size={13} /></small></button></li>
            ))}
            {!list.length && <li className="st-hint">Niciun produs.</li>}
          </ul>
        </>
      )}
    </div>
  );
}
